import React from 'react';
import { Box, Button, Pagination } from '@mui/material';
import './footer.css';

interface FooterProps {
    page: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    viewingPastReleases: boolean
    setViewPastReleases: () => void
    setViewRoadmap: () => void
}

const Footer: React.FC<FooterProps> = ({
    page,
    totalPages,
    onPageChange,
    viewingPastReleases,
    setViewPastReleases,
    setViewRoadmap
}) => {
    const handleChange = (_event: React.ChangeEvent<unknown>, value: number) => {
        onPageChange(value);
    };



    return (
        <Box className="footer-container">
            <Pagination
                count={totalPages}
                page={page}
                onChange={handleChange}
                className="footer-pagination"
                classes={{
                    ul: 'footer-pagination-ul'
                }}
            />
            <Button href="https://product.connectwise.com/communities/82-connectwise-home">
                Share Your Feedback
            </Button>
            {viewingPastReleases ? (
                <Button onClick={setViewRoadmap}>
                    Go Back To Roadmap
                </Button>
            ) : (
                <Button onClick={setViewPastReleases}>
                    View Past Releases
                </Button>
            )}
        </Box>
    );
};

export default Footer;
